import { NumberInputProps } from "react-admin";

import { Currency } from "../../../types";
import { CustomNumberInput } from "..";

const currencyToUSDRates: {
  [key in Currency]: number;
} = {
  [Currency.AED]: 0.272294,
  [Currency.ALL]: 0.012047,
  [Currency.ARS]: 0.000594,
  [Currency.AUD]: 0.653846,
  [Currency.BAM]: 0.60306,
  [Currency.BGN]: 0.60306,
  [Currency.BHD]: 2.659574,
  [Currency.BRL]: 0.163846,
  [Currency.BYN]: 0.318883,
  [Currency.CAD]: 0.74359,
  [Currency.CHF]: 1.282051,
  [Currency.CLP]: 0.001055,
  [Currency.CNY]: 0.142436,
  [Currency.COP]: 0.000229,
  [Currency.CZK]: 0.046154,
  [Currency.DKK]: 0.157983,
  [Currency.DZD]: 0.007005,
  [Currency.EGP]: 0.016813,
  [Currency.EUR]: 1.179487,
  [Currency.GBP]: 1.346154,
  [Currency.HKD]: 0.128205,
  [Currency.HUF]: 0.002804,
  [Currency.IDR]: 0.000060304,
  [Currency.ILS]: 0.290138,
  [Currency.INR]: 0.011436,
  [Currency.JPY]: 0.007141,
  [Currency.KRW]: 0.00074105,
  [Currency.KZT]: 0.001637,
  [Currency.MAD]: 0.111346,
  [Currency.MXN]: 0.05,
  [Currency.MYR]: 0.238564,
  [Currency.NOK]: 0.098638,
  [Currency.NZD]: 0.605378,
  [Currency.PAB]: 1.0,
  [Currency.PEN]: 0.2738,
  [Currency.PHP]: 0.017668,
  [Currency.PLN]: 0.268705,
  [Currency.QAR]: 0.274726,
  [Currency.RON]: 0.221603,
  [Currency.RSD]: 0.009745,
  [Currency.RUB]: 0.01086,
  [Currency.SAR]: 0.266667,
  [Currency.SEK]: 0.106538,
  [Currency.SGD]: 0.794872,
  [Currency.THB]: 0.031282,
  [Currency.TRY]: 0.018891,
  [Currency.TWD]: 0.035346,
  [Currency.UAH]: 0.021276,
  [Currency.USD]: 1.0,
  [Currency.VND]: 0.000037617,
  [Currency.ZAR]: 0.054333,
};

interface CurrencyConversionInputProps extends NumberInputProps {
  currency?: Currency;
  value: number | undefined;
}

function CurrencyConversionInput(props: CurrencyConversionInputProps) {
  // Adding currency abbreviation to label to help show users
  // which has been selected e.g. Price (USD)
  const labelValue = props.currency
    ? `${props.label} (${props.currency.toUpperCase()})`
    : props.label;

  // If the USD Amount message is not supposed to display
  // we are using the no-break space unicode character instead (\u00A0)
  // to preserve spacing between the inputs in the form
  const helperTextValue =
    props.currency && props.currency !== Currency.USD && props.value
      ? `USD Amount: $${(
          props.value * currencyToUSDRates[props.currency]
        ).toFixed(2)}`
      : "\u00A0";

  return (
    <CustomNumberInput
      label={labelValue}
      required={props.required}
      source={props.source}
      helperText={helperTextValue}
    />
  );
}

export default CurrencyConversionInput;
